var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"km-button noselect",class:( _obj = {}, _obj[_vm.size] = true, _obj.isBorder = _vm.isBorder === true, _obj.isBack = _vm.isBack === true, _obj ),on:{"click":_vm.clickHandle}},[(_vm.type==='loading')?_c('img',{staticClass:"roate",attrs:{"src":require("../../image/loading.png")}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21556fb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/components/button/main.vue
// module id = null
// module chunks = 